module.exports = __webpack_public_path__ + "static/media/loading.7d5237d6.gif";